/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ContentStudioConfig } from './contentStudioConfig';

export type ContentStudioStage3RequestConfig = ContentStudioConfig | null;
